// extracted by extract-css-chunks-webpack-plugin
module.exports = {"list-item":"Slide-0c1a27864528d9b8","fade":"Slide-938327e069ec23fa"};